import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserProfileType } from '../../../types/user';
import { profileCompletionCalculator } from '../../../utils/helperFunction/profileCompletionCalculator';

type StateType = UserProfileType & {
  profile_progress_percent?: number;
};
const initialState: StateType | null = null;
type ProfileUpdatePayload<
  K extends keyof UserProfileType = keyof UserProfileType,
> = {
  name: K;
  value: UserProfileType[K];
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: initialState as StateType | null,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfileType>) => {
      return {
        ...action.payload,
        profile_progress_percent: profileCompletionCalculator(action.payload),
      } as StateType;
    },
    updateUserProfile: (state, action: PayloadAction<ProfileUpdatePayload>) => {
      if (!state) return;
      return {
        ...state,
        [action.payload.name]: action.payload.value,
        profile_progress_percent: profileCompletionCalculator(state),
      };
    },
    clearUserProfile: () => null,
  },
});

export const { setUserProfile, clearUserProfile, updateUserProfile } =
  userProfileSlice.actions;
export default userProfileSlice.reducer;
